import config from '../package.json';
export var CONFIG_URL = {
  HOST_DEV: 'https://test-r.akulaku.net',
  HOST_ONLINE: 'https://r.akulaku.net',
  HOST_THIRD_DEV: 'https://test-device.akulaku.net',
  HOST_THIRD_ONLINE: 'https://device.akulaku.net',
  URL_FINGERPRINT: '/web/device/fingerprint',
  URL_DEVICE_BATTERY: '/device/battery',
  URL_DEVICE_SENSOR: '/device/sensor',
  URL_DEVICE_LOCATION: '/device/location',
  URL_DEVICE_APPLIST: '/device/other_app',
  URL_DEVICE_CONTACTS: '/device/contact',
  URL_UUID_DEV: 'http://test-api.iki.al.com/device_uuid/apply_device_uuid_web',
  URL_UUID_ONLINE: 'https://device.akulaku.net/device_uuid/apply_device_uuid_web',
  URL_LOCATION_DEV: 'https://dev-device.akulaku.net/device_uuid/apply_device_uuid',
  URL_LOCATION_ONLINE: 'https://device.akulaku.net/device_uuid/apply_device_uuid'
};
export var CONFIG_SDK_VERSION = config.version || '1.0.0.0'; //是否打印上传数据不传输数据，仅调试用，上线需设为false

export var CONFIG_DO_NOT_UPLOAD_DATA = false;